import { getSpecs } from './getSpecs'
import { getVehiclesImages } from './getVehiclesImages'

export async function getSkiVehicleGroupsData(context, groupsContent) {
	const APIunquotedSearch = await context.$axios.$get("/booking/unquotedSearch")

	const carClassCodeGroups = {
		awd: ['6H', '7', '7H', '9', '14', '14H'],
		suv: ['4', '5', '5H'],
		small: ['1', '2', '1H', '4H'],
		hybrid: ['1H', '4H', '5H', '6H', '7H', '14H'],
		minibus: ['10', '10X', '11X', '12'],
		skiRacks: ['2', '5H', '6H', '4', '4H', '5', '7', '7H', '14', '14H'],
		snowChains: ['1', '2', '1H', '4H', '5H', '4', '5', '7', '6H', '7H', '14', '14H', '9', '10', '10X', '11X', '12'],
	}

	const carClassCodeToDisplay = [...new Set([
		...carClassCodeGroups.awd,
		...carClassCodeGroups.suv,
		...carClassCodeGroups.small,
		...carClassCodeGroups.hybrid,
		...carClassCodeGroups.minibus,
	])]

	const vehicles = APIunquotedSearch?.result
		? carClassCodeToDisplay.map(classCode => APIunquotedSearch.result.find(vehicle => vehicle.classCode === classCode))
		: []

	const APIvehicleDetails = await Promise.all(
		vehicles.map(v =>
			context.$axios.$get("/booking/vehicleDetails", {
				params: { carClassId: v.carClassId },
			})
		)
	)

	vehicles.forEach((vehicle, index) => {
		if (vehicle.classCode === '6H') {
			vehicle.international = `${vehicle.international} Hybrid`
		}
		vehicle.details = APIvehicleDetails[index].result.filter(Boolean)
		vehicle.specs = getSpecs(vehicle)
		vehicle.images = getVehiclesImages({ vehicle, cdnUrl: context.$config.cdnUrl })
	})

	vehicles.forEach(vehicle => {
		vehicle.extraDetails = []
		if (carClassCodeGroups.skiRacks.includes(vehicle.classCode)) {
			vehicle.extraDetails.push({ icon: "chevron", content: "Ski Rack Compatible" })
		}
		if (carClassCodeGroups.snowChains.includes(vehicle.classCode)) {
			vehicle.extraDetails.push({ icon: "chevron", content: "Snow Chains Compatible" })
		}
	})

	const getVehiclesByClassCodes = group =>
		carClassCodeGroups[group].map(classCode =>
			vehicles.find(vehicle => vehicle.classCode === classCode)
		)

	return {
		vehicleGroups: [
			{
				title: "4WD Snow Car Hire",
				content: groupsContent.awd,
				vehicles: getVehiclesByClassCodes("awd"),
			},
			{
				title: "SUV Ski Car Rentals",
				content: groupsContent.suv,
				vehicles: getVehiclesByClassCodes("suv"),
			},
			{
				title: "Small Ski Car Rentals",
				content: groupsContent.small,
				vehicles: getVehiclesByClassCodes("small"),
			},
			{
				title: "Hybrid Fuel-Efficient Ski Car Rentals",
				content: groupsContent.hybrid,
				vehicles: getVehiclesByClassCodes("hybrid"),
			},
			{
				title: "Minibus Group Ski Trip Rental",
				content: groupsContent.minibus,
				vehicles: getVehiclesByClassCodes("minibus"),
			},
		],
		skiRacksVehicles: getVehiclesByClassCodes("skiRacks"),
		snowChainsVehicles: getVehiclesByClassCodes("snowChains"),
	}
}
